<template>
  <div class="preference">
    <div class="title-heading" style="margin: 10px 0 0 20px;">
      <!-- heading -->
      <p>
        <i style="position: relative; top: 5px;margin-right: 5px;">
          <img src="@/assets/titleBlock/heading1.png" alt="">
        </i>
        <!-- 邮箱设置 -->
        {{ $t("message.title.preference") }}
        <i style="position: relative; top: 5px;margin-left: 5px;">
          <img src="@/assets/titleBlock/heading2.png" alt="">
        </i>
      </p>
    </div>

    <div style="width: 98%;padding: 20px;overflow: hidden;">
      <div class="proference-title">logo上传</div>
      <table class="proference-table">
        <tbody>
          <tr>
            <td class="proference-table-left">LOGO(点击图片上传)</td>
            <td class="proference-table-right">
              <el-upload class="avatar-uploader upLoadBorder" action="" :show-file-list="false"
                :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus avatar-uploader-icon" @click="getUpdateImgId('')" v-if="addNewFile"></i>
                <img style="background: #409EFF;" v-else :src="imageUrl.url" @click="getUpdateImgId(imageUrl.id)"
                  class="avatar">
              </el-upload>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="proference-title">
        通用
        <div style="position: absolute;right: 20px;top: 8px;">
          <el-button type="primary" size="mini" @click="editInfo" icon="el-icon-edit" v-if="!edit">{{
            $t("message.button.edit") }}</el-button>

          <el-button type="danger" size="mini" @click="cancelForm" v-if="edit">{{ $t("message.button.cancel")
          }}</el-button>
          <el-button type="success" size="mini" @click="submitForm" v-if="edit">{{ $t("message.button.save")
          }}</el-button>
        </div>
      </div>

      <table class="proference-table" v-if="!edit">
        <tbody>
          <tr v-for="item in prefInfo">
            <td class="proference-table-left">{{ item.name }}</td>
            <td class="proference-table-right">{{ item.valueName }}</td>
          </tr>
        </tbody>
      </table>

      <table class="proference-table proference-table-edit" v-if="edit">
        <tbody>
          <tr v-for="item in prefInfo">
            <td class="proference-table-left">{{ item.name }}</td>
            <td class="proference-table-right">
              <el-input v-if="item.uiType == 1" style="width: 60%;" v-model="form[item.id]"
                oninput="value=value.replace(/[^\d]/g,'')" @input="change"></el-input>
              <el-select v-if="item.uiType == 3" v-model="form[item.id]" placeholder="" style="width: 60%;"
                @change="change()">
                <el-option v-for="selectList in item.listEntries" :label="selectList.name"
                  :value="selectList.value"></el-option>
              </el-select>
              <el-select v-if="item.uiType == 4" multiple v-model="form[item.id]" placeholder="" style="width: 60%;"
                @change="change()">
                <el-option v-for="selectList in item.listEntries" :label="selectList.name"
                  :value="selectList.value"></el-option>
              </el-select>
            </td>
          </tr>

          <!-- <tr>
            <td class="proference-table-left">{{$t('message.table.autoVersion')}}</td>
            <td class="proference-table-right">
              <el-select v-model="form[10001]" placeholder="" style="width: 60%;">
                <el-option :label="$t('message.table.yes')" value="1"></el-option>
                <el-option :label="$t('message.table.no')" value="0"></el-option>
              </el-select>
            </td>
          </tr>

          <tr>
            <td class="proference-table-left">{{$t('message.table.exportChange')}}</td>
            <td class="proference-table-right">
              <el-select v-model="form[10101]" placeholder="" style="width: 60%;">
                <el-option :label="$t('message.table.yes')" value="1"></el-option>
                <el-option :label="$t('message.table.no')" value="0"></el-option>
              </el-select>
            </td>
          </tr>

          <tr>
            <td class="proference-table-left">{{$t('message.table.isVerify')}}</td>
            <td class="proference-table-right">
              <el-select v-model="form[10102]" placeholder="" style="width: 60%;">
                <el-option :label="$t('message.table.yes')" value="1"></el-option>
                <el-option :label="$t('message.table.no')" value="0"></el-option>
              </el-select>
            </td>
          </tr>

          <tr>
            <td class="proference-table-left">{{$t('message.table.weightOfKey')}}</td>
            <td class="proference-table-right">
              <el-input style="width: 60%;" v-model="form[20001]" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </td>
          </tr>

          <tr>
            <td class="proference-table-left">{{$t('message.table.weightOfNonKey')}}</td>
            <td class="proference-table-right">
              <el-input style="width: 60%;" v-model="form[20002]" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </td>
          </tr> -->
        </tbody>
      </table>
      <!-- <div style="padding:0 50px 0 22%">
        <p style="font-size: 16px; color: #409EFF;margin-top: 7px;text-align: center;font-weight:600;">点击上传logo</p>
        <el-upload class="avatar-uploader upLoadBorder" action="" :show-file-list="false"
          :before-upload="beforeAvatarUpload">
          <i class="el-icon-plus avatar-uploader-icon" @click="getUpdateImgId('')" v-if="addNewFile"></i>
          <img style="background: #409EFF;" v-else :src="imageUrl.url" @click="getUpdateImgId(imageUrl.id)"  class="avatar">
        </el-upload>
      </div>
      <div style="height: 30px; position: relative; margin-bottom: 35px">
        <el-button type="primary" size="mini" style="float: right; margin-right: 45px; margin-top: 25px"
          @click="editInfo" icon="el-icon-edit" v-if="!edit">{{ $t("message.button.edit") }}</el-button>

        <el-button type="danger" size="mini" style="float: right; margin-right: 10px; margin-top: 25px"
          @click="cancelForm" v-if="edit">{{ $t("message.button.cancel") }}</el-button>
        <el-button type="success" size="mini" style="float: right; margin-right: 10px; margin-top: 25px"
          @click="submitForm" v-if="edit">{{ $t("message.button.save") }}</el-button>
      </div>
      <ul v-if="!edit" style="margin-top: 20px;overflow: hidden;">
        <li v-for="item in viewData" style="margin-top: 20px;" :key="item.index">
          <span style="display: inline-block;width: 40%;text-align: right;">{{item.name}}：</span>
          <span style="display: inline-block;width: 40%;text-align: center;">{{item.value}}</span>
        </li>
      </ul> -->
    </div>

    <!-- <div style="width: 45%;margin: 20px 0 0 20%;overflow: hidden;" v-if="edit">
      <el-form ref="form" :model="form" label-width="40%">
        <el-form-item :label="$t('message.table.autoVersion')">
          <el-select v-model="form[10001]" placeholder="" style="width: 100%;">
            <el-option :label="$t('message.table.yes')" value="1"></el-option>
            <el-option :label="$t('message.table.no')" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.table.exportChange')">
          <el-select v-model="form[10101]" placeholder="" style="width: 100%;">
            <el-option :label="$t('message.table.yes')" value="1"></el-option>
            <el-option :label="$t('message.table.no')" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.table.isVerify')">
          <el-select v-model="form[10102]" placeholder="" style="width: 100%;">
            <el-option :label="$t('message.table.yes')" value="1"></el-option>
            <el-option :label="$t('message.table.no')" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.table.weightOfKey')">
          <el-input v-model="form[20001]" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.table.weightOfNonKey')">
          <el-input v-model="form[20002]" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
      </el-form>
    </div> -->
  </div>

</template>

<style scoped>
.preference {
  width: 100%;
  height: 800px;
  background: #fff;
  overflow: hidden;
  overflow-y: auto;
}

.title-heading p {
  font-size: 18px;
  font-weight: 400;
  margin: 0;
}

.proference-title {
  font-size: 14px;
  font-weight: 300;
  padding: 12px 10px;
  border-radius: 3px 3px 0 0;
  background-color: #eee;
  font-family: inherit;
  font-weight: 400;
  position: relative;
}

.proference-table {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
}

.proference-table tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
  width: 100%;
}

.proference-table tr {
  margin: 0;
  padding: 0;
  border-top: 1px solid #dee2e6;
}

.proference-table td {
  padding: 16px 10px;
  margin: 0;
}

.proference-table-left {
  width: 40%;
  font-size: 14px;
  font-weight: 400;
}

.proference-table-right {
  font-size: 14px;
  font-weight: 400;
}

.el-select-dropdown__item {
  max-width: none !important;
}

.proference-table-edit td {
  padding: 8px;
}
</style>
<style>
.preference .upLoadBorder .el-upload {
  border: 1px dashed #d9d9d9;
}

.preference .avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 260px;
}

.preference .upLoadBorder .el-upload {
  border: 1px dashed #d9d9d9;
}

.preference .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.preference .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 260px;
  height: 155px;
  line-height: 155px;
  text-align: center;
}

.preference .avatar {
  width: 100%;
  display: block;
}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {
      upLoadDialog: false,
      upLoadProgress: 0,
      imageUrl: {},
      addNewFile: true,

      edit: false,
      viewData: [],
      prefInfo: {},
      form: {},
    };
  },
  mounted() { },
  methods: {
    change() {
      this.$forceUpdate();
    },
    getUpdateImgId(id) {
      this.updateImgId = id;
    },
    beforeAvatarUpload(file) {
      console.log(file);
      if (file.size / 1024 / 1024 > 4) { //仅支持4mb
        this.$message.error(this.$t('message.titleBlockImg.bigImg'));
        return false;
      };
      let AllImg = ['image/jpeg', 'image/gif', 'image/png', 'image/bmp']; //仅支持图片格式
      if (AllImg.indexOf(file.type) == -1) {
        this.$message.error(this.$t('message.titleBlockImg.notImg'));
        return false;
      };

      let vm = this;
      // let change_info = {};
      // if (this.$store.state.isItemTitleBlockImg) {
      //   change_info.changeId = this.$store.state.change_info.changeId;
      //   change_info.id = this.$store.state.objectId.id;
      //   change_info.classId = this.$store.state.objectId.classId;
      //   change_info.subClassId = this.$store.state.objectId.subClassId;
      // } else {
      //   change_info = this.$store.state.redLineTitleBlockImg;
      // };

      var path = window.sessionStorage.getItem("tenantName") + '/logo/' + file.name;
      //console.log(path);

      let fd = new FormData();
      fd.append('fileName', file.name);
      fd.append('fileSize', file.size);
      fd.append('path', path);

      let fileImg = {
        id: this.updateImgId,
        parentId: 0,
        parentClassId: 0,
        parentSubclassId: 0,
        parentChangeId: 0,
        iconName: file.name,
        iconPath: path,
      };

      axios.post('/swift-file/icons/uploadIconUrl', fd).then(function (res) {
        console.log(res);
        if (res.data.object.code == 501) {
          vm.$confirm(vm.$t('message.confirm.overwrite'), vm.$t('message.tips.tip'), {
            confirmButtonText: vm.$t('message.button.affirm'),
            cancelButtonText: vm.$t('message.button.cancel'),
            type: 'warning'
          }).then(() => {
            vm.updateFile(file, fileImg, res.data.object.url);
          }).catch(() => {
            vm.$message({
              type: 'info',
              message: vm.$t('message.tips.deleteCancel')
            });
          });
        } else if (res.data.object.code == 200) {
          vm.updateFile(file, fileImg, res.data.object.url);
        } else {
          vm.$message.error(res.data.object.message);
          return false;
        };
      });
    },
    updateFile(file, fd, url) {
      let vm = this;
      this.upLoadDialog = true; //展示进度条
      var reopt = {
        method: "PUT",
        url: url,
        withCredentials: false,
        headers: {
          'Content-Type': 'application/octet-stream'
        },
        validateStatus: function (status) {
          return status >= 200;
        },
        onUploadProgress: (progressEvent) => {
          console.log(progressEvent);
          if (progressEvent.lengthComputable) {
            var complete = (((progressEvent.loaded / progressEvent.total) * 100) | 0);
            vm.upLoadProgress = complete;
            if (complete >= 100) {
              vm.upLoadDialog = false;
              vm.upLoadProgress = 0; // 重新置0
            };
          }
        },
        maxRedirects: 0,
        data: file,
      };
      axios.request(reopt).then(function (response) {
        if (response.status = 200) {
          axios.post('/swift-file/icons/uploadIconMetadata', fd).then(function (res) {
            // console.log(res);
            if (res.data.code == 200) {
              vm.$message({
                message: vm.$t('message.success.upLoad'),
                type: 'success'
              });
              vm.getIconImg();
              vm.$store.commit("setSwiftLogo", "1");
            }
          });
        } else {
          console.log('Creating object using temporary signature failed!');
          console.log('status:' + response.status);
          console.log('\n');
        };
        console.log(response);
        console.log('\n');
      }).catch(function (err) {
        console.log('Creating object using temporary signature failed!');
        console.log(err);
        console.log('\n');
      });
    },
    editInfo() {
      this.edit = true;
    },
    submitForm() {
      this.edit = false;
      let vm = this;
      console.log(this.form);
      let postForm = {};
      for (let key in this.form) {
        if (this.form[key] instanceof Array) {
          let obj = this.form[key].join(";");
          postForm[key] = obj;
        } else {
          postForm[key] = this.form[key];
        };
      };
      //console.log(postForm);
      axios.post('/pmdm/admin/sys/updatePrefInfo', postForm).then((res) => {
        console.log(res);
        vm.getList();
      });
    },
    cancelForm() {
      this.edit = false;
    },
    getList() {
      let vm = this;
      axios.get('/pmdm/admin/sys/getPrefInfo').then(function (response) {
        var data_ = response.data.object.preference;
        console.log(data_);
        vm.prefInfo = data_;
        vm.viewData = [];
        // vm.form[20001] = data_.keyWeight.value;
        // vm.form[20002] = data_.nonKeyWeight.value;
        // vm.form[10001] = data_.autoRev.value;
        // vm.form[10101] = data_.exportReleaseChange.value;
        // vm.form[10102] = data_.isVerify.value;
        for (let key in data_) {
          let keyId = data_[key].id;

          vm.form[keyId] = data_[key].uiType == 4 ? data_[key].value.split(";") : data_[key].value;

          // if (keyId == 10001 || keyId == 10101 || keyId == 10102) {
          //   let obj = data_[key];
          //   if (data_[key].value == "1") {
          //     obj.value = vm.$t("message.table.yes");
          //   } else {
          //     obj.value = vm.$t("message.table.no");
          //   };
          //   vm.viewData.push(obj);
          // } else {
          //   vm.viewData.push(data_[key]);
          // };

          let selectLists = [];
          let oldSelectLists = data_[key].listEntries;
          for (let listKey in oldSelectLists) {
            let objList = {};
            objList.name = oldSelectLists[listKey];
            objList.value = listKey;
            selectLists.push(objList);
          };
          vm.prefInfo[key].listEntries = selectLists;
        };
        console.log(vm.form);
        console.log(vm.prefInfo);
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    getIconImg() {
      let vm = this;
      this.imageUrl = [],
        this.addNewFile = false;

      var getFile = {
        parentId: 0,
        parentClassId: 0,
        parentSubclassId: 0,
        parentChangeId: 0,
      };
      axios.get(`swift-file/icons/getIconsDownloadUrl${this.params(getFile)}`).then(res => {
        console.log(res);
        if (res.data.object.length) {
          vm.imageUrl = res.data.object[0];
          vm.addNewFile = false;
        } else {
          vm.addNewFile = true;
        };
      }).catch(_ => { })
    },
  },
  created() {
    this.getList();
    this.getIconImg();
  },
};
</script>
